import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { Constant } from "../../constant";
import { io } from 'socket.io-client';
import { AnonymousSubject } from "rxjs/internal/Subject";
import { MessageModel } from "../../models/message.model";
import { Alert } from "../../models/alert.model";

@Injectable({
    providedIn: 'root'
})
export class WsNotificationsService {

    public notificationObservable: Subject<Alert>;

    constructor(private constant: Constant) {
        this.notificationObservable = this.connect(this.constant.ws);
    }

    private connect(url: string): Subject<Alert> {
        const socket = io(url);

        const observable = new Observable(obs => {
            socket.on('notifications', (payload) => {
                obs.next(MessageModel.fromJson(JSON.parse(payload.replaceAll("'", '"'))));
            });

            return () => {
                socket.disconnect();
            }
        });

        const observer = {
            next: (payload: object): void => {
                socket.emit('notifications', payload);
            }
        };

        return Subject.create(observer, observable);
    }
}